import React, { useState, useEffect } from 'react';
import { GOOGLE_API_KEY, googleClientId, PROJECT_ID } from '../../redux/config';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ImGoogleDrive } from 'react-icons/im';

const GoogleDrivePicker = ({ setAccessTokens, type = null }) => {
    // const SCOPES = 'https://www.googleapis.com/auth/drive.metadata.readonly';
    const SCOPES = 'https://www.googleapis.com/auth/drive.file';
    const CLIENT_ID = googleClientId;
    const API_KEY = GOOGLE_API_KEY;
    const APP_ID = PROJECT_ID;

    const [tokenClient, setTokenClient] = useState(null);
    const [accessToken, setAccessToken] = useState(null);
    const [pickerInited, setPickerInited] = useState(false);
    const [gisInited, setGisInited] = useState(false);
    const [content, setContent] = useState('');

    useEffect(() => {
        const gapiLoaded = () => {
            window.gapi.load('client:picker', initializePicker);
        };

        const initializePicker = async () => {
            await window.gapi.client.load('https://www.googleapis.com/discovery/v1/apis/drive/v3/rest');
            setPickerInited(true);
            maybeEnableButtons();
        };

        const gisLoaded = () => {
            const tokenClientInstance = window.google.accounts.oauth2.initTokenClient({
                client_id: CLIENT_ID,
                scope: SCOPES,
                callback: '', // defined later
            });
            setTokenClient(tokenClientInstance);
            setGisInited(true);
            maybeEnableButtons();
        };

        const maybeEnableButtons = () => {
            if (pickerInited && gisInited) {
                // document.getElementById('authorize_button').style.visibility = 'visible';
            }
        };

        window.gapiLoaded = gapiLoaded;
        window.gisLoaded = gisLoaded;

        const scriptGapi = document.createElement('script');
        scriptGapi.src = 'https://apis.google.com/js/api.js';
        scriptGapi.onload = gapiLoaded;
        scriptGapi.async = true;
        scriptGapi.defer = true;
        document.body.appendChild(scriptGapi);

        const scriptGis = document.createElement('script');
        scriptGis.src = 'https://accounts.google.com/gsi/client';
        scriptGis.onload = gisLoaded;
        scriptGis.async = true;
        scriptGis.defer = true;
        document.body.appendChild(scriptGis);

        return () => {
            document.body.removeChild(scriptGapi);
            document.body.removeChild(scriptGis);
        };
    }, [pickerInited, gisInited]);

    const handleAuthClick = () => {
        tokenClient.callback = async (response) => {
            if (response.error !== undefined) {
                throw response;
            }
            console.log(response.access_token, "response.access_token");
            setAccessToken(response.access_token);
            setAccessTokens(response.access_token);
            localStorage.setItem('driveAccessToken', response.access_token)
            // document.getElementById('signout_button').style.visibility = 'visible';
            // await createPicker();
        };

        if (accessToken === null) {
            tokenClient.requestAccessToken({ prompt: 'consent' });
        } else {
            tokenClient.requestAccessToken({ prompt: '' });
        }
    };

    const handleSignoutClick = () => {
        if (accessToken) {
            setAccessToken(null);
            window.google.accounts.oauth2.revoke(accessToken);
            setContent('');
            document.getElementById('authorize_button').innerText = 'Authorize';
            document.getElementById('signout_button').style.visibility = 'hidden';
        }
    };

    const createPicker = () => {
        const view = new window.google.picker.View(window.google.picker.ViewId.DOCS);
        view.setMimeTypes('image/png,image/jpeg,image/jpg');
        const picker = new window.google.picker.PickerBuilder()
            .enableFeature(window.google.picker.Feature.NAV_HIDDEN)
            .enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED)
            .setDeveloperKey(API_KEY)
            .setAppId(APP_ID)
            .setOAuthToken(accessToken)
            .addView(view)
            .addView(new window.google.picker.DocsUploadView())
            .setCallback(pickerCallback)
            .build();
        picker.setVisible(true);
    };

    const pickerCallback = async (data) => {
        if (data.action === window.google.picker.Action.PICKED) {
            let text = `Picker response: \n${JSON.stringify(data, null, 2)}\n`;
            const document = data[window.google.picker.Response.DOCUMENTS][0];
            const fileId = document[window.google.picker.Document.ID];
            console.log(fileId);
            const res = await window.gapi.client.drive.files.get({
                fileId: fileId,
                fields: '*',
            });
            text += `Drive API response for first document: \n${JSON.stringify(res.result, null, 2)}\n`;
            setContent(text);
        }
    };

    return (
        <div>
            <GoogleOAuthProvider clientId={googleClientId}>
                <div className='d-flex'>
                    {type && type === "export" ?
                        <div>
                            <ImGoogleDrive onClick={handleAuthClick} />
                        </div>
                        :
                        // <button id="authorize_button" className='btn btn-outline-primary text-nowrap' onClick={handleAuthClick}>
                        //     Import From Google Drive
                        // </button>
                        <label class="custom-file-upload fs_14 fw_400 fn_Roboto hover-effect" onClick={handleAuthClick}>
                            Import From Google Drive
                        </label>
                    }
                    <pre id="content" style={{ whiteSpace: 'pre-wrap' }}>{content}</pre>
                </div>
            </GoogleOAuthProvider>
        </div>
    );
};

export default GoogleDrivePicker;
